import { render, staticRenderFns } from "./SearchBankVeritransModal.vue?vue&type=template&id=3b85e522&scoped=true"
import script from "./SearchBankVeritransModal.vue?vue&type=script&lang=js"
export * from "./SearchBankVeritransModal.vue?vue&type=script&lang=js"
import style0 from "./SearchBankVeritransModal.vue?vue&type=style&index=0&id=3b85e522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b85e522",
  null
  
)

export default component.exports